import React, { Component } from 'react';
import { connect } from 'react-redux';
import AlertOrMacroMetadata from '../../common/AlertOrMacroMetadata/AlertOrMacroMetadata';
import { ESCALATION_PARTNER } from 'constants/alerts';
import * as extract from '../../../extractFromState';
import { setSelectedWizardMacro } from '../../../actions/searchActions';
import {
  trackMacroWizardMacroSelected,
  trackEscalationClickBasedOnAlert,
} from '../../../analytics/searchEventAnalytics';
import { getIconNameForMacro, checkIfMacroIsNew } from '../../../util/decisionTreeUtil';
import striptags from 'striptags';
import { replaceHtmlEntities } from '../../../util';
import * as commerceUtil from 'util/commerceUtil';
import MWAlert from '../MWAlert/MWAlert';
import { handleEscalationPopup } from 'actions/popupActions';
import {
  Container,
  HeaderSection,
  ResultSection,
  AlertSection,
  MacroResult,
  MacroResultHeader,
  TypeIcon,
  CheckIcon,
  Thanks,
  NewMarker,
  MacroResultTitle,
  MacroResultContent,
} from './MWList.styles';

export class MWList extends Component {
  handleSelectMacro(macro) {
    // eslint-disable-next-line
    const { setSelectedWizardMacro } = this.props;
    setSelectedWizardMacro(macro);
    trackMacroWizardMacroSelected();
  }

  showImageIndicator(text) {
    // eslint-disable-next-line no-useless-escape
    const regex = /<img([\w\W]+?)[\/]?>/;

    return regex.test(text);
  }

  getMacroPreview(macro) {
    const htmlWithTriggersStripped = commerceUtil.removeCommerceTriggers(macro.text);

    return striptags(replaceHtmlEntities(htmlWithTriggersStripped)).slice(0, 230);
  }

  renderMacro(macro) {
    return (
      <MacroResult key={macro.objectId} onClick={() => this.handleSelectMacro(macro)}>
        <AlertOrMacroMetadata resource={macro} />
        <MacroResultHeader>
          <TypeIcon src={`images/${getIconNameForMacro(macro)}.svg`} />
          {checkIfMacroIsNew(macro) && <NewMarker>[NEW]</NewMarker>}
          <MacroResultTitle>{macro.fullSubheading}</MacroResultTitle>
        </MacroResultHeader>
        <MacroResultContent>
          <span>{this.getMacroPreview(macro)}...</span>
        </MacroResultContent>
      </MacroResult>
    );
  }

  handleEscalationClick(escalationReason, alertId, escalateToBusinessAsExpert = false) {
    trackEscalationClickBasedOnAlert(alertId);
    this.props.handleEscalationPopup(this.props.selectedTicket, escalationReason, escalateToBusinessAsExpert);
  }

  renderEscalationAlert(alert) {
    const escalateToBusinessAsExpert = alert.type === ESCALATION_PARTNER;

    return (
      <MWAlert
        key={alert.id}
        resource={alert}
        onEscalateTicket={(escalationReason) =>
          this.handleEscalationClick(escalationReason, alert.id, escalateToBusinessAsExpert)
        }
      />
    );
  }

  renderEscalationMacro(macro) {
    return (
      <MWAlert
        key={macro.id}
        resource={macro}
        onEscalateTicket={(escalationReason) => this.handleEscalationClick(escalationReason, null)}
      />
    );
  }

  render() {
    const { macroList, tagPath, currentTab, escalationMacroList, escalationAlerts } = this.props;
    const showThankYouNote = currentTab === 'assigned' || currentTab === 'live_chat';
    const totalResultLength = escalationMacroList.length + escalationAlerts.length + macroList.length;

    return (
      <Container>
        {!!totalResultLength && (
          <>
            <HeaderSection>
              <CheckIcon src="/images/check-mark-icon-large.svg" alt="check mark" />
              {showThankYouNote && <Thanks>Thank you for categorizing this ticket!</Thanks>}
              We found{' '}
              <b>
                {totalResultLength} result{totalResultLength > 1 ? 's' : ''}
              </b>{' '}
              that may resolve this {tagPath.toLowerCase()} inquiry:
            </HeaderSection>
            {(!!escalationAlerts.length || !!escalationMacroList.length) && (
              <AlertSection>
                {escalationAlerts.map((alert) => this.renderEscalationAlert(alert))}
                {escalationMacroList.map((macro) => this.renderEscalationMacro(macro))}
              </AlertSection>
            )}
            <ResultSection>{macroList.map((macro) => this.renderMacro(macro))}</ResultSection>
          </>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  tagPath: extract.extractCurrentMacroWizardPath(state),
  macroList: extract.getOrderedMacroList(state),
  escalationMacroList: extract.getEscalationMacroList(state),
  escalationAlerts: extract.getAllEscalationAlertsForLevel(state),
  currentTab: extract.extractSelectedInboxTab(state),
  isAdmin: state.user.isAdmin,
  selectedTicket: extract.extractSelectedTicketFromState(state),
});

const mapStateToDispatch = (dispatch) => ({
  setSelectedWizardMacro: (macro) => {
    dispatch(setSelectedWizardMacro(macro));
  },
  handleEscalationPopup: (ticket, escalationReason, escalateToBusinessAsExpert) => {
    dispatch(handleEscalationPopup(ticket, escalationReason, escalateToBusinessAsExpert));
  },
});

export default connect(mapStateToProps, mapStateToDispatch)(MWList);
